/**
 * lazyRetry — React.lazy with self-healing chunk loading.
 * After a deploy (or a dev-server rebuild), old hashed chunks 404 for users
 * on a stale shell. Strategy: retry the import up to 3× with backoff
 * (1.2s / 2.5s / 5s) so transient rebuild windows ride through; if it still
 * fails, force ONE full reload (per minute, guarded) to pick up fresh hashes.
 */
import { lazy } from "react";

const RELOAD_KEY = "maldek-chunk-reload-at";
const DELAYS_MS = [1200, 2500, 5000];

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export function lazyRetry(factory) {
  return lazy(async () => {
    let lastErr;
    try {
      return await factory();
    } catch (err) {
      lastErr = err;
    }
    for (const delay of DELAYS_MS) {
      await sleep(delay);
      try {
        return await factory();
      } catch (err) {
        lastErr = err;
      }
    }
    let last = 0;
    try { last = Number(sessionStorage.getItem(RELOAD_KEY) || 0); } catch { /* noop */ }
    if (Date.now() - last > 60000) {
      try { sessionStorage.setItem(RELOAD_KEY, String(Date.now())); } catch { /* noop */ }
      window.location.reload();
      await sleep(8000); // keep Suspense fallback up while the reload lands
    }
    throw lastErr;
  });
}
